import React, { useMemo, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty } from 'lodash'

import { Button } from '@/components/buttons/Button'
import { fetchKeywordsRepository } from '@/reducers/keywords/keywords.actions'

import { Select } from '../Select'

export const KeywordSelect = ({ ...props }) => {
  const dispatch = useDispatch()
  const { keywords, loading, language: keywordsLanguage } = useSelector((state) => state.keywords)
  const { language: playbookLanguage } = useSelector((state) => state.playbook?.playbook)
  const [showDefinitions, setShowDefinitions] = useState(true)

  useEffect(() => {
    // get keywords if language is different or we don't have them yet
    // note: non english/spanish languages will currently always have isEmpty(keywords) be true, but since this useEffect
    // is hooked on playbookLanguage change it doesn't actually result in extra API calls
    if (playbookLanguage !== keywordsLanguage || (isEmpty(keywords) && !loading)) {
      dispatch(fetchKeywordsRepository(playbookLanguage))
    }
  }, [playbookLanguage])

  const options = useMemo(
    () =>
      keywords.map((keyword) => ({
        value: keyword.krid,
        label: keyword.name,
        description:
          showDefinitions && (keyword.definition || !isEmpty(keyword.examples)) ? (
            <>
              {keyword.definition && (
                <div>
                  <strong>Definition</strong>: {keyword.definition}
                </div>
              )}
              {!isEmpty(keyword.examples) && (
                <div>
                  <strong>Examples</strong>: {keyword.examples.join(', ')}
                </div>
              )}
            </>
          ) : undefined,
      })),
    [keywords, showDefinitions]
  )

  return (
    <>
      <Button
        link
        onClick={(event) => {
          event.stopPropagation()
          setShowDefinitions((prev) => !prev)
        }}
      >
        {showDefinitions ? 'Hide AI Library Definitions' : 'Show AI Library Definitions'}
      </Button>
      <Select
        loading={loading}
        options={options}
        onChange={({ value }) => {
          // nullify side selection when changing categories so we can set default side
          if (props.field.value !== value) props.form.setFieldValue('trigger.side', null)
        }}
        {...props}
      />
    </>
  )
}
